<template>
  <div class="form-warp">
    <div class="container">
      <van-form validate-first scroll-to-error @submit="onSubmit" @failed="onFailed">
        <div class="form-box">
          <div class="form-cell">
            <div class="form-title">公司名</div>
            <div class="form-input form-input-block">
              <van-field v-model="company" name="company" placeholder="请输入您的公司名称" />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">部门</div>
            <div class="form-input form-input-block">
              <van-field v-model="department" name="department" placeholder="请输入您的公司部门" />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">
              姓名
              <sup>*</sup>
            </div>
            <div class="form-input form-input-block">
              <van-field
                v-model="name"
                name="name"
                placeholder="请输入您的姓名"
                :rules="[{ required: true, message: '请输入您的姓名' }]"
              />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">
              联系电话
              <sup>*</sup>
            </div>
            <div class="form-input form-input-block">
              <van-field
                v-model="tel"
                name="tel"
                placeholder="请输入您的联系电话"
                :rules="[{ pattern: /^(1)\d{10}$/, message: '请输入正确的电话号码' }]"
              />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">
              电子邮箱
            </div>
            <div class="form-input form-input-block">
              <van-field
                v-model="email"
                name="email"
                placeholder="请输入您的电子邮箱"
              />
            </div>
          </div>
        </div>
        <div class="form-btn-cell">
          <van-button type="primary" block>发送需求</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
export default {
  components: {},
  data() {
    return {
      company: "",
      department: "",
      name: "",
      tel: "",
      email: "",
      apply_id: null,
      type: null
    };
  },
  created() {
    this.getData();
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  methods: {
    getData() {
      console.log(this.$route.query);
      this.apply_id = this.$route.query.id;
      this.type = this.$route.query.type;
    },
    onSubmit() {
      this.axios
        .post(process.env.VUE_APP_API + "/contact/add", {
          apply_id: this.apply_id,
          company: this.company,
          department: this.department,
          name: this.name,
          tel: this.tel,
          email: this.email
        })
        .then(res => {
          console.log(res.data.code);
          if (res.data.code === 1000) {
            this.$router.push({
              path: "/result",
              query: { id: this.apply_id, type: this.type }
            });
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.msg
            }).then(() => {});
          }
        })
        .catch(function() {
          Dialog.alert({
            title: "提示",
            message: "网络错误"
          }).then(() => {});
        });
    },
    onFailed(values) {
      console.log("onFailed", values);
      Toast.fail(values.errors[0].message);
    }
  }
};
</script>
